/**
 * External dependencies
 */
import { get } from 'lodash';

export const getResourceConnectId = state => get(state, 'ui.syncResourceConnectModal.resourceConnectId', null);